const PILLARS = [
  {
    eyebrow: '01 / Operator, not reseller',
    title: 'A single operator behind the platform.',
    body: "CyLogic builds, operates, and continuously monitors CyCloud. We don't resell someone else's cloud, and we don't assemble it from a stack you have to manage. The platform team, the compliance team, the day-2 operations team — all CyLogic. Federal contractors and regulated enterprises get a single accountable operator behind the platform, not a chain of vendor escalations.",
  },
  {
    eyebrow: '02 / One boundary you can inherit',
    title: 'Deploy inside our boundary, not around it.',
    body: 'FedRAMP High Ready boundary — pursuing Authorization — with IL5-aligned controls as the unified compliance baseline. CyLogic designed CyCloud so federal contractors deploy inside our boundary rather than build their own. Less ATO sustainment, less compliance staff, faster time to mission.',
  },
  {
    eyebrow: '03 / Predictable pricing without the Broadcom math',
    title: 'You pay one number. We handle the platform stack.',
    body: 'CyLogic absorbs the platform-stack economics — VCF licensing, hardware refresh, FedRAMP sustainment, the operations team — and prices CyCloud as a managed service at a fixed monthly rate. You pay one number. We handle the Broadcom licensing, the Dell refresh cycle, and the Equinix colocation cost.',
  },
]

export function WhyCyLogic() {
  return (
    <section id="why" className="bg-white py-20 lg:py-24 scroll-mt-16">
      <div className="mx-auto max-w-7xl px-6">
        <header className="max-w-3xl mb-12">
          <h2 className="text-3xl sm:text-4xl font-semibold text-navy tracking-tight">
            Why CyLogic operates CyCloud the way we do.
          </h2>
          <p className="mt-3 text-base text-navy/70">
            Three operator-level differences from AWS GovCloud, Azure Government, and the
            build-your-own federal cloud path.
          </p>
        </header>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {PILLARS.map((p) => (
            <article
              key={p.eyebrow}
              className="bg-chalk border border-mist rounded-card p-6 sm:p-7 shadow-card hover:shadow-card-hover transition-shadow"
            >
              <div className="font-data text-xs uppercase tracking-wide text-mint font-medium">
                {p.eyebrow}
              </div>
              <h3 className="mt-3 text-lg font-semibold text-navy leading-snug">
                {p.title}
              </h3>
              <p className="mt-3 text-sm text-navy/75 leading-relaxed">{p.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
